export class LotUnitConstants {
    static logCallPopupWindowWidth = 1000;
    static logCallPopupWindowHeight = 800;
}
